'use client';

import React from 'react';

const reasons = [
    {
        title: 'Be among the first to try Wisly',
        desc: 'Get early access to Wisly before it becomes publicly available and experience the platform from the beginning.',
        icon: (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                    d="M10 2.5l2.32 4.7 5.18.75-3.75 3.66.89 5.16L10 14.33l-4.64 2.44.89-5.16L2.5 7.95l5.18-.75L10 2.5z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
    },
    {
        title: 'Choose how you use Wisly',
        desc: 'Whether you\'re a student, parent, tutor, or institution, request access for the experience designed for you.',
        icon: (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle
                    cx="10"
                    cy="7"
                    r="3"
                    stroke="currentColor"
                    strokeWidth="1.5"
                />
                <path
                    d="M4 17c.6-3 2.6-4.5 6-4.5s5.4 1.5 6 4.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        ),
    },
    {
        title: 'We’ll keep you informed',
        desc: 'Once testing begins, we’ll send further information to the email address you provide.',
        icon: (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <rect
                    x="2.5"
                    y="4"
                    width="15"
                    height="12"
                    rx="2"
                    stroke="currentColor"
                    strokeWidth="1.5"
                />
                <path
                    d="M3 5l7 5 7-5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
    },
];

export default function EarlyAccessInfo() {
    return (
        <div className="flex flex-col gap-8 h-full">

            {/* Why request early access */}
            <div>
                <p className="text-xs font-bold uppercase tracking-[0.12em] text-[#3757FF] mb-6">
                    Early access
                </p>

                <h3 className="text-2xl font-bold text-gray-900 tracking-tight mb-3">
                    Get closer to the future of learning.
                </h3>

                <p className="text-sm text-gray-500 leading-relaxed max-w-md">
                    Wisly brings students, parents, tutors, and institutions
                    together in one connected educational ecosystem.
                </p>

                <div className="space-y-5 mt-7">
                    {reasons.map((reason) => (
                        <div
                            key={reason.title}
                            className="flex gap-4"
                        >
                            {/* Icon */}
                            <div className="w-10 h-10 rounded-xl bg-[#3757FF]/10 text-[#3757FF] flex items-center justify-center shrink-0">
                                {reason.icon}
                            </div>

                            {/* Content */}
                            <div>
                                <h4 className="text-sm font-bold text-gray-900 mb-1">
                                    {reason.title}
                                </h4>

                                <p className="text-sm text-gray-500 leading-relaxed">
                                    {reason.desc}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Divider */}
            <div className="h-px bg-gray-200" />

            {/* Wisly ecosystem */}
            <div>
                <p className="text-xs font-bold uppercase tracking-[0.12em] text-gray-400 mb-3">
                    The Wisly ecosystem
                </p>

                <div className="flex flex-wrap gap-2">
                    {['Students', 'Parents', 'Tutors', 'Institutions'].map(
                        (type) => (
                            <span
                                key={type}
                                className="px-3 py-1.5 rounded-lg bg-gray-50 border border-gray-200 text-xs font-semibold text-gray-600"
                            >
                                {type}
                            </span>
                        )
                    )}
                </div>
            </div>
        </div>
    );
}